export const BADGE_SUBTEXT: Record<string, string> = {
  curious: 'Asking the right questions',
  informed: 'Building the real picture',
  empowered: 'Ready to act with confidence',
}
